import { getCurrentInstance } from 'vue'

// 访问vuex
export const useStore = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$store
}
// 访问router
export const useRouter = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$router
}
// 访问route
export const useRoute = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$route
}

// 清空页面缓存
export const useCleanCacheView = () => {
  try {
    const vm = getCurrentInstance()
    if (!vm) throw new Error('must be called in setup')
      return vm.proxy.$root
  } catch (error) {
    console.log(error)
  }
  // try {
  //   const vm = getCurrentInstance()
  //   if (vm && vm.proxy && vm.proxy.$root) {
  //     vm.proxy.$root.$emit('cleanCacheView')
  //   } else {
  //     // 备用方案：尝试通过全局Vue实例访问
  //     if (
  //       typeof window !== 'undefined' &&
  //       window.vm &&
  //       window.vm.$root
  //     ) {
  //       window.vm.$root.$emit('cleanCacheView')
  //     }
  //   }
  // } catch (error) {
  //   console.error('清空缓存时出错:', error)
  //   // 备用方案：如果路由器方法失败，尝试直接访问全局Vue实例
  //   try {
  //     if (
  //       typeof window !== 'undefined' &&
  //       window.vm &&
  //       window.vm.$root
  //     ) {
  //       window.vm.$root.$emit('cleanCacheView')
  //     }
  //   } catch (fallbackError) {
  //     console.error(
  //       '备用清空缓存方案也失败了:',
  //       fallbackError
  //     )
  //   }
  // }
}
